/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import createStore from './src/store';
import HistoryEventTypes from './src/constants/history-event-types';
import TransitionConfigTypes from './src/constants/transition-config-types';
import { addCustomValidationRules } from './src/utilities/form-utility';

/**
 * Replace the Node export replaceRouterComponent function
 * This will return our newly Redux connected router
 */
exports.replaceRouterComponent = ({ history }) => {
  // Create store
  const store = createStore(history);

  // Add custom custom validation rules
  addCustomValidationRules(store);

  return ({ children }) => (
    <Provider store={store}>
      <Router history={history}>{children}</Router>
    </Provider>
  );
};

const getUserConfirmation = (pathname, callback) => {
  const event = new CustomEvent(HistoryEventTypes.EXITING, { detail: { pathname } });
  window.dispatchEvent(event);
  setTimeout(() => {
    callback(true);
  }, TransitionConfigTypes.TRANSITION_TIMEOUT);
}

let history;
if (typeof document !== 'undefined') {
  history = createHistory({ getUserConfirmation });
  // block must return a string to conform
  history.block((location, action) => location.pathname);
}

exports.replaceHistory = () => history;



// WEBPACK FOOTER //
// ./gatsby-browser.js